import { render, staticRenderFns } from "./TakeNum.vue?vue&type=template&id=079190fe&scoped=true"
import script from "./TakeNum.vue?vue&type=script&lang=js"
export * from "./TakeNum.vue?vue&type=script&lang=js"
import style0 from "./TakeNum.vue?vue&type=style&index=0&id=079190fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079190fe",
  null
  
)

export default component.exports